import React from "react";

interface DayPickerProps {
  label: string | number;
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  title?: string | number;
}

const DayPicker: React.FC<DayPickerProps> = ({
  label,
  selected,
  onClick,
  title,
}) => {
  return (
    <div
      className={`weekday label-${label} ${selected ? "selected" : ""}`}
      onClick={onClick}
      title={title !== undefined ? String(title) : undefined}
      data-testid={`${label}-btn`}
    >
      {label}
    </div>
  );
};

export default DayPicker;
